import { axiosAccess } from "@config/axiosConfig";
import { ApplicationDetailsPayload } from "@modules/application-section/application-details/types";

export const getApplicationDetails = async (
  payload: ApplicationDetailsPayload
) => {
  const { access_id } = payload; 
  return await axiosAccess.get(`/access_details/${access_id}`);
};
